import { OBJECT_TYPES } from '../configuratorConstants';

function incrementElementCount(counts, type) {
    switch (type) {
        case OBJECT_TYPES.WINDOW:
            counts.windows.small++;
            break;
        case OBJECT_TYPES.PANORAMIC_WINDOW:
            counts.windows.large++;
            break;
        case OBJECT_TYPES.DOOR:
            counts.doors++;
            break;
        case OBJECT_TYPES.OUTLET:
            counts.sockets.single++;
            break;
        case OBJECT_TYPES.OUTLET_DOUBLE:
            counts.sockets.double++;
            break;
        case OBJECT_TYPES.SWITCH:
        case OBJECT_TYPES.SWITCH_DOUBLE:
            counts.lighting.switches++;
            break;
        case OBJECT_TYPES.LIGHT_CEILING:
            counts.lighting.fixtures++;
            break;
        case OBJECT_TYPES.HEATER:
            counts.climate.heaters++;
            break;
        case OBJECT_TYPES.INTERNAL_AIR_CONDITIONER:
            counts.climate.airConditioners++;
            break;
        case OBJECT_TYPES.WINDOW_BLINDS:
            counts.climate.windowBlinds++;
            break;
        case OBJECT_TYPES.TOILET:
            counts.plumbing.toilets++;
            break;
        case OBJECT_TYPES.HAND_BASIN:
            counts.plumbing.sinks++;
            break;
        case OBJECT_TYPES.WATER_HEATER:
            counts.plumbing.waterHeaters++;
            break;
        case 'shower':
            counts.plumbing.showers++;
            break;
        case 'urinal':
            counts.plumbing.urinals++;
            break;
        case 'partition':
            counts.plumbing.partitions++;
            break;
        case 'shower_drain':
            counts.plumbing.showerDrains++;
            break;
        case 'bed':
            counts.furniture.beds++;
            break;
        case 'desk':
            counts.furniture.desks++;
            break;
        case 'chair':
            counts.furniture.chairs++;
            break;
        default:
            break;
    }
}

export const projectToKPModules = (projectState) => {
    if (!projectState || !projectState.projectObjects) {
        return [];
    }

    const resultModules = [];

    const getElementsForModule = (module, allFloorObjects) => {
        const counts = {
            windows: { large: 0, small: 0 },
            doors: 0,
            sockets: { double: 0, single: 0 },
            lighting: { switches: 0, fixtures: 0 },
            climate: { heaters: 0, airConditioners: 0, windowBlinds: 0 },
            plumbing: { sinks: 0, toilets: 0, waterHeaters: 0, showers: 0, urinals: 0, partitions: 0, showerDrains: 0 },
            furniture: { beds: 0, desks: 0, chairs: 0 },
            jacks: 0
        };

        // Используем Set для отслеживания уже подсчитанных элементов по ID
        const countedElementIds = new Set();

        // Сначала собираем все connectedJoints для этого модуля
        const connectedJoints = allFloorObjects.filter(obj => 
            obj.type === OBJECT_TYPES.DOCKING_JOINT && 
            (obj.moduleA_id === module.id || obj.moduleB_id === module.id)
        );
        
        // Создаем Set ID всех элементов из стыков, чтобы не считать их из wallSegments
        const jointElementIds = new Set();
        connectedJoints.forEach(joint => {
            (joint.elements || []).forEach(element => {
                if (element.id) {
                    jointElementIds.add(element.id);
                }
            });
        });

        if (module.wallSegments) {
            Object.values(module.wallSegments).forEach(segment => {
                // Пропускаем сегменты, которые находятся на стыке (isDocked или jointId)
                if (segment.isDocked || segment.jointId) {
                    return;
                }
                
                (segment.elements || []).forEach(element => {
                    // Пропускаем копии элементов (isAdjacentCopy) - они не должны считаться отдельно
                    if (element.isAdjacentCopy) {
                        return;
                    }
                    // Пропускаем элементы, которые уже были подсчитаны
                    if (element.id && countedElementIds.has(element.id)) {
                        return;
                    }
                    // Пропускаем элементы, которые находятся в стыке (они будут посчитаны в connectedJoints)
                    if (element.id && jointElementIds.has(element.id)) {
                        return;
                    }
                    incrementElementCount(counts, element.type);
                    if (element.id) {
                        countedElementIds.add(element.id);
                    }
                });
            });
        }
        
        (module.freeElements || []).forEach(element => {
            // Пропускаем копии элементов
            if (element.isAdjacentCopy) {
                return;
            }
            // Пропускаем элементы, которые уже были подсчитаны
            if (element.id && countedElementIds.has(element.id)) {
                return;
            }
            // Пропускаем элементы, которые находятся в стыке
            if (element.id && jointElementIds.has(element.id)) {
                return;
            }
            incrementElementCount(counts, element.type);
            if (element.id) {
                countedElementIds.add(element.id);
            }
        });

        // Считаем элементы из стыков только для модуля A (чтобы не считать дважды)
        connectedJoints.forEach(joint => {
            // Считаем элементы только если этот модуль является moduleA_id
            // Это гарантирует, что каждый стык будет посчитан только один раз
            if (joint.moduleA_id !== module.id) {
                return;
            }
            
            (joint.elements || []).forEach(element => {
                // Пропускаем копии элементов
                if (element.isAdjacentCopy) {
                    return;
                }
                // Пропускаем элементы, которые уже были подсчитаны из wallSegments
                if (element.id && countedElementIds.has(element.id)) {
                    return;
                }
                incrementElementCount(counts, element.type);
                if (element.id) {
                    countedElementIds.add(element.id);
                }
            });
        });

        return counts;
    };

    for (const floorId in projectState.projectObjects) {
        const floorObjects = projectState.projectObjects[floorId];
        const projectModules = floorObjects.filter(obj => obj.type === OBJECT_TYPES.MODULE);

        projectModules.forEach(module => {
            let genericType = 'residential';
            if (module.subtype === 'corridor') {
                genericType = 'corridor';
            }

            const moduleElementCounts = getElementsForModule(module, floorObjects);
            
            const modulePayload = { 
                type: genericType,
                subtype: module.subtype,
                templateId: module.templateId, // <-- ОСЬ ЦЕЙ РЯДОК ДОДАНО
                elements: moduleElementCounts,
                cellsWide: module.cellsWide,
                cellsLong: module.cellsLong,
                x: module.x,
                y: module.y,
                height: 2880,
                label: module.label
            };

            // Логирование для отладки кухни и пральни
            if (module.subtype === 'kitchen' || module.subtype === 'laundry') {
                console.log(`🏠 [projectToKPModules] Модуль ${module.subtype}:`, {
                    subtype: modulePayload.subtype,
                    templateId: modulePayload.templateId,
                    label: modulePayload.label,
                    elements: modulePayload.elements
                });
            }

            resultModules.push(modulePayload);
        });
    }

    return resultModules;
};

export const getProjectInfo = (projectState) => {
    if (!projectState) {
        return {
            projectName: 'Новый проект',
            clientName: '',
            description: 'Проект модульной постройки'
        };
    }
    return {
        projectName: projectState.projectName || 'Новый проект',
        clientName: projectState.clientName || '',
        description: projectState.description || 'Проект модульной постройки',
    };
};